module.exports = __webpack_public_path__ + "static/saf-246dc5b19ff9c441176fd7d0e6b88f70.png";